export default "__VITE_ASSET__4f7a35c6__"